interface TooltipRow { name: string; value: number; color: string }
export function buildChartTooltip(title: string, month: string, unit: string, rows: TooltipRow[], showTotal: boolean): HTMLElement {
  const root = document.createElement('div')
  root.className = 'pacsort-chart-tooltip'
  const add = (parent: HTMLElement, tag: string, className: string, text: string) => {
    const element = document.createElement(tag)
    element.className = className
    element.textContent = text
    parent.appendChild(element)
    return element
  }
  const format = (value: number) => `${new Intl.NumberFormat('en-GB', { maximumFractionDigits: unit === 'kr' ? 2 : 0 }).format(value)}${unit ? ' ' + unit : ''}`
  const header = add(root, 'div', 'pacsort-tooltip-header', '')
  add(header, 'span', 'pacsort-tooltip-title', title)
  add(header, 'strong', 'pacsort-tooltip-month', month)
  const body = add(root, 'div', 'pacsort-tooltip-body', '')
  for (const row of rows) {
    const item = add(body, 'div', `pacsort-tooltip-row${row.value === 0 ? ' is-zero' : ''}`, '')
    const swatch = add(item, 'span', 'pacsort-tooltip-swatch', '')
    swatch.style.backgroundColor = row.color
    swatch.setAttribute('aria-hidden', 'true')
    add(item, 'span', 'pacsort-tooltip-name', row.name)
    add(item, 'strong', 'pacsort-tooltip-value', format(row.value))
  }
  if (showTotal) {
    const footer = add(root, 'div', 'pacsort-tooltip-total', '')
    add(footer, 'span', '', 'Total')
    add(footer, 'strong', '', format(rows.reduce((total, row) => total + row.value, 0)))
  }
  return root
}
